import { Pipe, PipeTransform, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Observer, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

/*
 * Translate Master data select options with translation property of descEn and descTh
 * eg. { ..., descEn: Thai, descTh: ไทย }
 *
 * Usage:
 *   array item | masterDataTranslate | async
 *
 */
@Pipe({ name: 'masterDataTranslate', pure: true })
export class MasterDataTranslatePipe implements PipeTransform, OnDestroy {
  private TRANSLATE_PROPERTY_KEY: string = 'masterData';
  private onLangChangeSubscription: Subscription = new Subscription();

  constructor(private translate: TranslateService) {}

  ngOnDestroy(): void {
    this.onLangChangeSubscription.unsubscribe();
  }

  transform(object: any): Observable<string> {

    return new Observable((observer: Observer<string>) => {
      observer.next(object[this.translate.instant(this.TRANSLATE_PROPERTY_KEY)]);

      this.onLangChangeSubscription = this.translate.onLangChange.pipe(distinctUntilChanged()).subscribe(() => {
        observer.next(object[this.translate.instant(this.TRANSLATE_PROPERTY_KEY)]);
      });
    });
  }
}
